import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { DataresolverService } from './dataresolver.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'folder/:id',
    loadChildren: () => import('./folder/folder.module').then( m => m.FolderPageModule)
  },
  {
    path: 'alt-login',
    loadChildren: () => import('./alt-login/alt-login.module').then( m => m.AltLoginPageModule)
  },

  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'driver-management',
    loadChildren: () => import('./driver-management/driver-management.module').then( m => m.DriverManagementPageModule)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then( m => m.DashboardPageModule)
  },
  {
    path: 'pending',
    loadChildren: () => import('./pending/pending.module').then( m => m.PendingPageModule)
  },
  {
    path: 'live',
    loadChildren: () => import('./live/live.module').then( m => m.LivePageModule)
  },
  {
    path: 'completed',
    loadChildren: () => import('./completed/completed.module').then( m => m.CompletedPageModule)
  },
  {
    path: 'popover',
    loadChildren: () => import('./popover/popover.module').then( m => m.PopoverPageModule)
  },
  {
    path: 'global',
    loadChildren: () => import('./global/global.module').then( m => m.GlobalPageModule)
  },
  {
    path: 'emp-signature',
    loadChildren: () => import('./emp-signature/emp-signature.module').then( m => m.EmpSignaturePageModule)
  },
  {
    path: 'userdetail',
    loadChildren: () => import('./userdetail/userdetail.module').then( m => m.UserdetailPageModule)
  },
  {
    path: 'update-time-page',
    loadChildren: () => import('./update-time-page/update-time-page.module').then( m => m.UpdateTimePagePageModule)
  },
  {
    path: 'assign-vehicle',
    loadChildren: () => import('./assign-vehicle/assign-vehicle.module').then( m => m.AssignVehiclePageModule)
  },
  {
    path: 'completedtask',
    loadChildren: () => import('./completedtask/completedtask.module').then( m => m.CompletedtaskPageModule)
  },
  {
    path: 'weekly-inspection',
    loadChildren: () => import('./weekly-inspection/weekly-inspection.module').then( m => m.WeeklyInspectionPageModule)
  },
  {
    path: 'daily-inspection',
    loadChildren: () => import('./daily-inspection/daily-inspection.module').then( m => m.DailyInspectionPageModule)
  },
  {
    path: 'enrouteclickpage',
    loadChildren: () => import('./enrouteclickpage/enrouteclickpage.module').then( m => m.EnrouteclickpagePageModule)
  },
  {
    path: 'enrouteclickpage/:id',
    loadChildren: () => import('./enrouteclickpage/enrouteclickpage.module').then( m => m.EnrouteclickpagePageModule)
  },
  {
    path: 'enrouteclickpage/:id/:id2',
    resolve:{datas:DataresolverService},
    loadChildren: () => import('./enrouteclickpage/enrouteclickpage.module').then( m => m.EnrouteclickpagePageModule)
  },
  {
    path: 'emp-signatures',
    loadChildren: () => import('./emp-signatures/emp-signatures.module').then( m => m.EmpSignaturesPageModule)
  },
  {
    path: 'obtainclientsign',
    loadChildren: () => import('./obtainclientsign/obtainclientsign.module').then( m => m.ObtainclientsignPageModule)
  },
  {
    path: 'signature-verification',
    loadChildren: () => import('./signature-verification/signature-verification.module').then( m => m.SignatureVerificationPageModule)
  },
  {
    path: 'obtainclientsigntest',
    loadChildren: () => import('./obtainclientsign/obtainclientsign.module').then( m => m.ObtainclientsignPageModule)
  },
  {
    path: 'refresh',
    loadChildren: () => import('./obtainclientsign/obtainclientsign.module').then( m => m.ObtainclientsignPageModule)
  },
  {
    path: 'routetrip',
    loadChildren: () => import('./routetrip/routetrip.module').then( m => m.RoutetripPageModule)
  },
  {
    path: 'changedate',
    loadChildren: () => import('./changedate/changedate.module').then( m => m.ChangedatePageModule)
  },
  {
    path: 'refreshdashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then( m => m.DashboardPageModule)
  },
  {
    path: 'altdashboard',
    loadChildren: () => import('./altdashboard/altdashboard.module').then( m => m.AltdashboardPageModule)
  },




];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, onSameUrlNavigation: 'reload' })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
